<div class="line-container">
    <ul class="line-colours">
        <li class="one left"></li>
        <li class="two left"></li>
        <li class="three left"></li>
    </ul>
</div>

<nav class="navbar navbar-expand-lg navbar-light bg-light">
    <div class="container">
        <!-- <a class="navbar-brand" [routerLink]="['/home']"> -->
        <a class="navbar-brand">
            <img src="./assets/img/logo_tenaris.png" alt="Tenaris">
        </a>

        <div class="nav-item dropdown">
            <select class="custom-select" [(ngModel)]="selectedLanguage" (change)="onChangeLanguage()">
                <ng-container *ngFor="let lang of this.languageList.lang">
                    <option value = {{lang.value}}>{{lang.viewValue}}</option>
                </ng-container>
            </select>
        </div>
    </div>
</nav>